import { useEscapeKey } from '@/hooks/useEscapeKey';
import type { ReactNode } from 'react';

type ConfirmModalProps = {
  title: string;
  message?: ReactNode;
  confirmText?: string;
  confirmKind?: 'primary' | 'danger';
  onConfirm: () => void;
  onCancel: () => void;
};

/** Jednoduché potvrzovací modal okno (potvrdit / zrušit). */
export function ConfirmModal({
  title,
  message,
  confirmText = 'Potvrdit',
  confirmKind = 'primary',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  useEscapeKey(onCancel);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Zavřít"
        onClick={onCancel}
        className="absolute inset-0 bg-black/30 backdrop-blur-sm cursor-default"
      />
      <div className="relative w-full max-w-sm bg-surface rounded-2xl shadow-modal p-6 reveal">
        <h2 className="text-lg font-bold text-text mb-1">{title}</h2>
        {message && <p className="text-sm text-text-secondary mb-5">{message}</p>}
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="text-sm font-semibold text-text-secondary hover:text-text px-4 py-2 cursor-pointer"
          >
            Zrušit
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`text-sm font-bold rounded-lg px-5 py-2 text-white cursor-pointer transition-colors ${
              confirmKind === 'danger'
                ? 'bg-danger hover:opacity-90'
                : 'bg-action hover:bg-action-dark'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
